import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { useMediaQuery } from '@mui/material';

import ForNonDesktop from '../../components/ForNonDesktop';
import ChatButton from '../../components/HeaderActions/ChatButton';
import CloseButton from '../../components/HeaderActions/CloseButton';
import { selectCourse } from '../../db/courses/selectors';
import { i18nNS } from '../../i18n';
import routes, { CourseParams } from '../../pages/routes';
import { useAppSelector } from '../../store/hooks';
import { CourseRole } from '../../types';
import { getUnseenComments } from '../../utils/activities';
import { forDesktop } from '../../utils/media-queries';

const useStudentAnalyticsHeaderActionsVM = () => {
  const params = useParams<CourseParams>();
  const course = useAppSelector((state) => selectCourse(state, params.courseShortId));
  const isStudent = course?.myRole === CourseRole.STUDENT;

  const numUnseenComments = course ? getUnseenComments(course) : 0;

  return { isStudent, params, numUnseenComments };
};

const StudentAnalyticsHeaderActions = () => {
  const isDesktop = useMediaQuery(forDesktop);
  const { t } = useTranslation([i18nNS.COURSES]);

  const { isStudent, params, numUnseenComments } = useStudentAnalyticsHeaderActionsVM();

  return (
    <>
      <CloseButton
        to={isStudent ? routes.courseTimeline.url(params) : routes.courseAnalytics.url(params)}
        edge={isDesktop ? 'end' : undefined}
        aria-label={t('click_to_close_student_analytics', { ns: i18nNS.COURSES })}
      />
      <ForNonDesktop>
        <ChatButton edge="end" numUnseenComments={numUnseenComments} />
      </ForNonDesktop>
    </>
  );
};

export default StudentAnalyticsHeaderActions;
